import PropTypes from 'prop-types';
import React from 'react';

import { SILVER_SAND } from '@wetransfer/transfer/constant/colors';

const DownloadSmall = ({ className, color, onClick }) => (
  <svg className={className} onClick={onClick} viewBox="0 0 24 24">
    <path
      d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10 10-4.477 10-10zm-9 1.492V7.998C13 7.446 12.552 7 12 7c-.556 0-1 .447-1 .998v5.48l-2.53-2.53c-.385-.385-1.022-.39-1.413.002-.393.393-.39 1.022-.002 1.412l4.247 4.247c.192.19.447.288.702.288.26.003.514-.095.708-.29l4.247-4.246c.383-.385.387-1.022-.003-1.412-.394-.393-1.023-.392-1.413-.002L13 13.492zM0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12z"
      fill={color}
      fillRule="evenodd"
    />
  </svg>
);

DownloadSmall.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  onClick: PropTypes.func,
};

DownloadSmall.DefaultProps = {
  color: SILVER_SAND,
};

export default DownloadSmall;
